import React from "react";
import MainHero from "../components/user/home/MainHero";
import FAQ from "../components/user/home/FAQ";
import Ofertahome from "../components/user/home/Ofertahome";
import GoogleReviews from "../components/user/home/GoogleReviews";
import HeroSection from "../components/user/home/Herosection";
import Marquee from "../components/user/home/Marquee";
import Program from "../components/user/home/Programs";

const Home = () => {
  return (
    <div className="">
      <MainHero />
      <Program /> <Marquee />
      <GoogleReviews />
      <HeroSection />
      <FAQ />
    </div>
  );
};

export default Home;
